"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddArticle = AddArticle;
exports.DelArticle = DelArticle;
exports.ListArticle = ListArticle;
exports.UpdateArticle = UpdateArticle;
exports.activeCustomersApi = activeCustomersApi;
exports.camiListArticle = camiListArticle;
exports.changeState = changeState;
exports.changeStatePost = changeStatePost;
exports.changeUserPhone = changeUserPhone;
exports.companyAutoListByTypestApi = companyAutoListByTypestApi;
exports.companyAutoListByTypetApi = companyAutoListByTypetApi;
exports.companyappAutoListApi = companyappAutoListApi;
exports.downLoadKami = downLoadKami;
exports.exportCustomerOrder = exportCustomerOrder;
exports.getAllCustomer = getAllCustomer;
exports.getCardPackageDetail = getCardPackageDetail;
exports.getCardPackageList = getCardPackageList;
exports.getComboList = getComboList;
exports.getCustomerOrderClose = getCustomerOrderClose;
exports.getKMDetailsExprot = getKMDetailsExprot;
exports.getOrderDetail = getOrderDetail;
exports.getRelatedCards = getRelatedCards;
exports.getUserByCustomer = getUserByCustomer;
exports.refreshKamiQrcode = refreshKamiQrcode;
exports.removeKami = removeKami;
exports.sendBatchMessage = sendBatchMessage;
exports.sendMessage = sendMessage;
exports.updateBasicData = updateBasicData;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
/**
 * 列表
 * @param pram
 * @constructor
 */
function ListArticle() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var appId = pram.appId,
    customerId = pram.customerId,
    status = pram.status,
    limit = pram.limit,
    orderName = pram.orderName,
    page = pram.page,
    _pram$dateValueNum = pram.dateValueNum,
    dateValueNum = _pram$dateValueNum === void 0 ? [] : _pram$dateValueNum,
    innerRemark = pram.innerRemark,
    projectNumber = pram.projectNumber,
    companyId = pram.companyId,
    fuCardId = pram.fuCardId,
    sendType = pram.sendType,
    sendProjectId = pram.sendProjectId,
    kamiType = pram.kamiType,
    innerCompanyName = pram.innerCompanyName,
    bindPhone = pram.bindPhone,
    secretPassword = pram.secretPassword;
  var _ref = dateValueNum || [],
    _ref2 = _slicedToArray(_ref, 2),
    startTime = _ref2[0],
    endTime = _ref2[1];
  console.log('搜索参数:', pram);
  return (0, _request.default)({
    url: '/admin/order/customer/list',
    method: 'GET',
    params: {
      appId: appId,
      customerId: customerId,
      status: status,
      limit: limit,
      orderName: orderName,
      page: page,
      startTime: startTime,
      endTime: endTime,
      innerRemark: innerRemark,
      projectNumber: projectNumber,
      companyId: companyId,
      fuCardId: fuCardId,
      sendType: sendType,
      sendProjectId: sendProjectId,
      kamiType: kamiType,
      innerCompanyName: innerCompanyName,
      bindPhone: bindPhone,
      secretPassword: secretPassword
    }
  });
}

/**
 * 删除订单
 * @param {*} orderNo
 * @returns
 */
function DelArticle(orderNo) {
  return (0, _request.default)({
    url: "/admin/order/customer/delete/".concat(orderNo),
    method: 'delete',
    params: {
      id: orderNo
    }
  });
}

/**
 * 详情
 * @param id
 * @constructor
 */
function getOrderDetail(id) {
  return (0, _request.default)({
    url: "/admin/order/customer/detail/".concat(id),
    method: 'GET',
    params: {
      id: id
    }
  });
}
var handSubmit = function handSubmit() {
  var datas = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var comboId = datas.comboId,
    companyId = datas.companyId,
    customerId = datas.customerId,
    _datas$dataRange = datas.dataRange,
    dataRange = _datas$dataRange === void 0 ? [] : _datas$dataRange,
    orderName = datas.orderName,
    quantity = datas.quantity,
    remark = datas.remark,
    totalPrice = datas.totalPrice,
    type = datas.type,
    salesUnitPrice = datas.salesUnitPrice,
    price = datas.price,
    dueTime = datas.dueTime,
    fuCardId = datas.fuCardId,
    appId = datas.appId,
    status = datas.status,
    innerRemark = datas.innerRemark,
    innerCompanyName = datas.innerCompanyName,
    kamiType = datas.kamiType,
    fuPackageId = datas.fuPackageId,
    fuConfig = datas.fuConfig,
    cardValidStart = datas.cardValidStart,
    cardValidEnd = datas.cardValidEnd,
    orderValidStart = datas.orderValidStart,
    orderValidEnd = datas.orderValidEnd,
    _datas$orderTimeRange = datas.orderTimeRange,
    orderTimeRange = _datas$orderTimeRange === void 0 ? [] : _datas$orderTimeRange,
    _datas$cardTimeRange = datas.cardTimeRange,
    cardTimeRange = _datas$cardTimeRange === void 0 ? [] : _datas$cardTimeRange,
    _datas$couponPackages = datas.couponPackages,
    couponPackages = _datas$couponPackages === void 0 ? [] : _datas$couponPackages,
    projectNumber = datas.projectNumber,
    salesPrice = datas.salesPrice,
    sendType = datas.sendType;

  // 处理旧的数据范围格式
  var _dataRange = _slicedToArray(dataRange, 2),
    startTime = _dataRange[0],
    endTime = _dataRange[1];

  // 如果有新的订单时间范围但没有旧的订单时间字段值，则使用新的
  if (orderTimeRange && orderTimeRange.length === 2) {
    if (!startTime) startTime = orderTimeRange[0];
    if (!endTime) endTime = orderTimeRange[1];
  }

  // 确保有效期字段有值（优先使用直接传入的字段）
  var finalOrderValidStart = orderValidStart || startTime;
  var finalOrderValidEnd = orderValidEnd || endTime;

  // 处理福卡有效期（从cardTimeRange提取）
  var finalCardValidStart = cardValidStart;
  var finalCardValidEnd = cardValidEnd;
  if (cardTimeRange && cardTimeRange.length === 2) {
    if (!finalCardValidStart) finalCardValidStart = cardTimeRange[0];
    if (!finalCardValidEnd) finalCardValidEnd = cardTimeRange[1];
  }
  var _ref3 = {},
    cid = _ref3.cid,
    cname = _ref3.cname,
    comid = _ref3.comid,
    comname = _ref3.comname;
  try {
    // 兼容两种格式：
    // 1) "id_name" 字符串
    // 2) 直接的 id（数字或字符串）
    if (typeof companyId === 'string' && companyId.includes('_')) {
      var _companyId$split = companyId.split('_'),
        _companyId$split2 = _slicedToArray(_companyId$split, 2),
        coid = _companyId$split2[0],
        coname = _companyId$split2[1];
      cid = coid;
      cname = coname;
    } else {
      cid = companyId;
      cname = datas.companyName || '';
    }
    if (typeof comboId === 'string' && comboId.includes('_')) {
      var _comboId$split = comboId.split('_'),
        _comboId$split2 = _slicedToArray(_comboId$split, 2),
        crid = _comboId$split2[0],
        crname = _comboId$split2[1];
      comid = crid;
      comname = crname;
    } else {
      comid = comboId;
      comname = datas.comboName || '';
    }
  } catch (error) {}
  var submitDatas = {
    companyId: cid,
    companyName: cname,
    customerId: customerId,
    orderName: orderName,
    quantity: quantity,
    remark: remark,
    totalPrice: totalPrice,
    type: type,
    fuCardId: fuCardId,
    appId: appId,
    innerRemark: innerRemark,
    status: status,
    innerCompanyName: innerCompanyName,
    kamiType: kamiType,
    // 同时保留新旧字段名，确保兼容性
    startTime: startTime,
    endTime: endTime,
    // 新的有效期字段
    cardValidStart: finalCardValidStart,
    cardValidEnd: finalCardValidEnd,
    orderValidStart: finalOrderValidStart,
    orderValidEnd: finalOrderValidEnd,
    couponPackages: couponPackages,
    projectNumber: projectNumber || '',
    // 确保项目编号字段有值或为空字符串,
    salesPrice: salesPrice,
    salesUnitPrice: salesUnitPrice,
    sendType: sendType
  };
  if (type == 1) {
    // 套餐类型
    submitDatas = _objectSpread(_objectSpread({}, submitDatas), {}, {
      comboId: comid,
      comboName: comname,
      price: price
    });
  }
  ;
  if (type == 2) {
    // 福豆类型
    submitDatas = _objectSpread(_objectSpread({}, submitDatas), {}, {
      price: price,
      dueTime: dueTime
    });
  }
  ;
  if (type == 3) {
    // 权益卡包类型
    submitDatas = _objectSpread(_objectSpread({}, submitDatas), {}, {
      price: price,
      fuPackageId: fuPackageId,
      fuConfig: fuConfig
    });
  }
  ;

  // 添加调试信息
  console.log('处理后的提交数据项目编号:', projectNumber);
  console.log('API提交数据:', submitDatas);
  return submitDatas;
};

/**
 * 新增
 * @param pram
 * @constructor
 */
function AddArticle(pram) {
  return (0, _request.default)({
    url: '/admin/order/customer/add',
    method: 'post',
    data: handSubmit(pram)
  });
}

/**
 * 更新
 * @param pram
 * @constructor
 */
function UpdateArticle(pram) {
  return (0, _request.default)({
    url: '/admin/order/customer/update',
    method: 'put',
    data: _objectSpread(_objectSpread({}, handSubmit(pram)), {}, {
      id: pram.id
    })
  });
}

/**
 * 更新客户订单基础数据
 * @param data
 * @constructor
 */
function updateBasicData(data) {
  return (0, _request.default)({
    url: '/admin/order/customer/update-basic',
    method: 'put',
    data: data
  });
}

/**
 * 变更状态
 */
function changeState(id, status) {
  return (0, _request.default)({
    url: "/admin/order/customer/status/".concat(id, "/").concat(status),
    method: 'put'
  });
}
function changeStatePost() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _data$id = data.id,
    id = _data$id === void 0 ? '' : _data$id,
    _data$status = data.status,
    status = _data$status === void 0 ? '' : _data$status;
  return (0, _request.default)({
    url: "/admin/order/customer/status/".concat(id, "/").concat(status),
    method: 'post',
    data: data
  });
}

/**
 * 卡密列表
 * @param pram
 * @constructor
 */
function camiListArticle() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref4 = pram || {},
    companyId = _ref4.companyId,
    limit = _ref4.limit,
    orderName = _ref4.orderName,
    page = _ref4.page,
    phone = _ref4.phone,
    status = _ref4.status,
    cusOrderId = _ref4.cusOrderId,
    kamiId = _ref4.kamiId,
    secretKey = _ref4.secretKey,
    customerId = _ref4.customerId;
  var data = {
    companyId: companyId,
    limit: limit,
    orderName: orderName,
    page: page,
    phone: phone,
    status: status,
    cusOrderId: cusOrderId,
    kamiId: kamiId,
    secretKey: secretKey,
    customerId: customerId
  };
  return (0, _request.default)({
    url: '/admin/order/kami/list',
    method: 'GET',
    params: data
  });
}
;

/**
 * 修改用户手机号
 * @param {*} id
 * @param {*} phone
 * @returns
 */
function changeUserPhone(id, phone) {
  return (0, _request.default)({
    url: "/admin/order/kami/".concat(id, "/").concat(phone),
    method: 'put',
    params: {
      id: id,
      phone: phone
    }
  });
}

/**
 * 移除卡密
 * @param {*} id
 * @returns
 */
function removeKami(id) {
  return (0, _request.default)({
    url: "/admin/order/kami/".concat(id),
    method: 'delete'
  });
}

/**
 * 发送短信
 * @param {*} id
 * @returns
 */
function sendMessage(id) {
  return (0, _request.default)({
    url: "/admin/order/kami/".concat(id),
    method: 'post',
    data: {
      id: id
    }
  });
}

/**
 * 批量发送卡密短信
 * @param {*} id
 * @returns
 */
function sendBatchMessage(id, url) {
  return (0, _request.default)({
    url: "/admin/order/customer/send",
    method: 'post',
    data: {
      id: id,
      url: url
    }
  });
}

/**
 * 下载卡密
 * @param {*} id
 */
function downLoadKami(id) {
  return (0, _request.default)({
    url: "/admin/order/customer/download/".concat(id),
    method: 'post',
    data: {
      id: id
    }
  });
}

/**
 * 选择套餐
 */
function getComboList(params) {
  return (0, _request.default)({
    url: "/admin/store/product/combo/autoList",
    method: 'get',
    params: params
  });
}

/**
 * 客户列表-不分页
 * @param {*} types
 * @returns
 */
function getAllCustomer() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: "/admin/customers/options",
    method: 'get',
    params: params
  });
}

// 更新卡密二维码
function refreshKamiQrcode(cusOrderId) {
  return (0, _request.default)({
    url: "/admin/order/customer/qrCode/".concat(cusOrderId),
    method: 'post',
    data: {
      cusOrderId: cusOrderId
    }
  });
}

/**
 * 小程序列表自动补全
 */
function companyappAutoListApi(params) {
  return (0, _requestMapi.default)({
    url: "/mapi/user/admin/company-app/simple/list",
    method: 'GET',
    params: params
  });
}

/**
 * 商家列表自动补全
 */
function companyAutoListByTypetApi(params) {
  // return request({
  //     url: `/admin/business/supplier/autoListByType`,
  //     method: 'GET',
  //     params,
  // })
  return (0, _requestMapi.default)({
    url: "/mapi/user/supplier/autoListByType",
    method: 'GET',
    params: params
  });
}

/**
 * 店铺列表自动补全
 */
function companyAutoListByTypestApi(params) {
  // return request({
  //     url: `/admin/offlineStore/autoList`,
  //     method: 'GET',
  //     params,
  // })

  return (0, _requestMapi.default)({
    url: '/mapi/user/offline-store/auto-list',
    method: 'GET',
    params: params
  });
}

/**
 * 根据customerid查询用户
 */
function getUserByCustomer(params) {
  return (0, _request.default)({
    url: "/admin/user/autoList",
    method: 'GET',
    params: params
  });
}

/**
 * 作废订单
 */
function getCustomerOrderClose(cusOrderId) {
  return (0, _request.default)({
    url: "/admin/order/customer/".concat(cusOrderId),
    method: 'delete'
  });
}

/**
 * 卡密详细导出
 *
 */
function getKMDetailsExprot(params) {
  return (0, _request.default)({
    url: "/admin/order/customer/export/customer_kami",
    method: 'get',
    params: params
  });
}

/**
 * 订单导出
 * 携带与列表查询相同的筛选参数，不包含分页参数
 * 返回文件下载地址 { fileName: 'http://...' }
 */
function exportCustomerOrder() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var appId = pram.appId,
    customerId = pram.customerId,
    status = pram.status,
    orderName = pram.orderName,
    _pram$dateValueNum2 = pram.dateValueNum,
    dateValueNum = _pram$dateValueNum2 === void 0 ? [] : _pram$dateValueNum2,
    innerRemark = pram.innerRemark,
    projectNumber = pram.projectNumber,
    companyId = pram.companyId,
    fuCardId = pram.fuCardId,
    sendProjectId = pram.sendProjectId,
    sendType = pram.sendType,
    kamiType = pram.kamiType,
    innerCompanyName = pram.innerCompanyName,
    bindPhone = pram.bindPhone,
    secretPassword = pram.secretPassword;
  var _ref5 = dateValueNum || [],
    _ref6 = _slicedToArray(_ref5, 2),
    startTime = _ref6[0],
    endTime = _ref6[1];
  return (0, _request.default)({
    url: '/admin/order/customer/export/simple',
    method: 'get',
    params: {
      appId: appId,
      customerId: customerId,
      status: status,
      orderName: orderName,
      startTime: startTime,
      endTime: endTime,
      innerRemark: innerRemark,
      projectNumber: projectNumber,
      companyId: companyId,
      sendProjectId: sendProjectId,
      fuCardId: fuCardId,
      sendType: sendType,
      kamiType: kamiType,
      innerCompanyName: innerCompanyName,
      bindPhone: bindPhone,
      secretPassword: secretPassword
    }
  });
}

/**
 * 获取客户
 */
function activeCustomersApi(params) {
  // return request({
  //     url: `/admin/customers/active-customers`,
  //     method: 'GET',
  //     params
  // });
  return (0, _requestMapi.default)({
    url: "/mapi/user/customer/active-customers",
    method: 'GET',
    params: params
  });
}

/**
 * 获取权益卡包列表
 */
function getCardPackageList(data) {
  return (0, _request.default)({
    url: '/admin/card/package/list',
    method: 'GET',
    params: data
  });
}

/**
 * 获取卡包关联的福卡列表
 */
function getRelatedCards(packageId) {
  return (0, _request.default)({
    url: '/admin/card/package/related-cards',
    method: 'GET',
    params: {
      packageId: packageId
    }
  });
}

/**
 * 获取单个权益卡包详情
 */
function getCardPackageDetail(id) {
  return (0, _request.default)({
    url: '/admin/card/package/detail',
    method: 'GET',
    params: {
      id: id
    }
  });
}